export const LABEL_COLORS = {
    '#61bd4f': 'Green',
    '#f2d600': 'Yellow',
    '#ff9f1a': 'Orange',
    '#eb5a46': 'Red',
    '#c377e0': 'Purple',
    '#0079bf': 'Blue',
    '#00c2e0': 'Sky',
    '#51e898': 'Lime',
    '#ff78cb': 'Pink',
    '#344563': 'Dark'
};